import React, { useState, useEffect } from 'react';
import styles from './userInfo.module.scss';
import { Col, Image } from 'react-bootstrap';
import { changePassword, changeUserName, getUserData, changeUserPosition } from '../../../services/util/userSettings';
import UserInfoForm from './userInfoForm';
import CSSLoader from '../../shared/cssLoader';
import { useNavigate } from "react-router-dom";

function UserInfo(props) {
    let [isNameSubmissionLoading, setNameSubmissionLoading] = useState(false);
    let [isPasswordSubmissionLoading, setPasswordSubmissionLoading] = useState(false);
    let [isPositionSubmissionLoading, setPositionSubmissionLoading] = useState(false)
    let [isPageLoading, setPageLoading] = useState(false);
    let [userData, setUserData] = useState({});
    let history = useNavigate();
    let [userPremission, setUserPermission] = useState({});
    let [textbox, setTextBox] = useState({
        is_full_name_activated: false,
        is_password_activated: false,
        is_position_activated: false,
    })

    const onSubmitUserName = async (values) => {
        setNameSubmissionLoading(true);
        let respond = await changeUserName(values.firstName, values.lastName);
        if (respond.success === true) {
            let userName = values.firstName + ' ' + values.lastName;
            setNameSubmissionLoading(false);
            localStorage.setItem('name', userName);
            setTextBox({ is_full_name_activated: false, is_password_activated: false });
            window.location.reload();
        } else {
            setNameSubmissionLoading(false);
        }
    }

    const onSubmitUserPosition = async (values) => {
        setPositionSubmissionLoading(true);
        let respond = await changeUserPosition(values.position);
        if (respond.success === true) {
            let userPosition = values.position;
            setPositionSubmissionLoading(false);
            localStorage.setItem('position', userPosition);
            setTextBox({ is_full_name_activated: false, is_password_activated: false, is_position_activated: false });
            window.location.reload();
        } else {
            setPositionSubmissionLoading(false);
        }
    }

    const onSubmitUserPassword = async (values) => {
        setPasswordSubmissionLoading(true);
        let respond = await changePassword(values.currentPassword, values.newPassword);
        if (respond.success === true) {
            setPasswordSubmissionLoading(false);
            setTextBox({ is_full_name_activated: false, is_password_activated: false });
            history('/signin')
        } else {
            setPasswordSubmissionLoading(false);
        }
    }

    const activateFullNameTextBox = () => {
        setTextBox((prevState) => ({
            ...prevState,
            is_full_name_activated: true,
        }))
    }

    const deactivateNameTextBoxes = () => {
        setTextBox((prevState) => ({
            ...prevState,
            is_full_name_activated: false,
        }))
    }

    const activatePositionTextBox = () => {
        setTextBox((prevState) => ({
            ...prevState,
            is_position_activated: true,
        }))
    }

    const deactivatePositionTextBox = () => {
        setTextBox((prevState) => ({
            ...prevState,
            is_position_activated: false,
        }))
    }

    const activatePasswordTextBox = () => {
        setTextBox((prevState) => ({
            ...prevState,
            is_password_activated: true,
        }))
    }

    const deactivatePasswordTextBox = () => {
        setTextBox((prevState) => ({
            ...prevState,
            is_password_activated: false,
        }))
    }

    const resetTextFields = () => {
        setTextBox({
            is_full_name_activated: false,
            is_password_activated: false
        })
    }

    const LoadInitialData = async () => {
        setPageLoading(true);
        let respond = await getUserData();
        if (respond.success === true) {
            setUserData(respond.data);
            setPageLoading(false);
        } else {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        LoadInitialData();
        let permissionObject = localStorage.getItem('Permissions');
        setUserPermission(JSON.parse(permissionObject));
    }, [])

    return (
        <div>
            {isPageLoading === true ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={styles.userDetailsBox}>
                        <div className={styles.userAvatarBodyContainer}>
                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/user_settings_page_avatar.png`} fluid className={styles.userAvatar} />
                            {/* <span className={styles.IconBox}>
                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.625 1.87519C10.7892 1.71104 10.984 1.58082 11.1985 1.49199C11.413 1.40315 11.6429 1.35742 11.875 1.35742C12.1071 1.35742 12.337 1.40315 12.5515 1.49199C12.766 1.58082 12.9608 1.71104 13.125 1.87519C13.2892 2.03934 13.4194 2.23422 13.5082 2.44869C13.597 2.66317 13.6428 2.89304 13.6428 3.12519C13.6428 3.35734 13.597 3.58721 13.5082 3.80168C13.4194 4.01616 13.2892 4.21104 13.125 4.37519L4.6875 12.8127L1.25 13.7502L2.1875 10.3127L10.625 1.87519Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span> */}
                        </div>
                        <div className={styles.userDetailsContainer}>
                            <p className={styles.userDetailsBodyTopic}>{userData.first_name + ' ' + userData.last_name}</p>
                            <p className={styles.userDetailsBodyValue}>{userData.position}</p>
                            <p className={styles.userDetailsBodyValue}>{userData.user_email}</p>
                            <p className={styles.userDetailsBodyCompanyName}>{userData.user_company_name}</p>
                        </div>
                    </div>
                    <div className={styles.userInfoForm}>
                        <Col sm={8}>
                            <UserInfoForm userPremission={userPremission} userData={userData} onSubmitUserName={onSubmitUserName} onSubmitUserPosition={onSubmitUserPosition} onSubmitUserPassword={onSubmitUserPassword} isNameSubmissionLoading={isNameSubmissionLoading} isPositionSubmissionLoading={isPositionSubmissionLoading} isPasswordSubmissionLoading={isPasswordSubmissionLoading} textboxStatus={textbox} activateFullNameTextBox={activateFullNameTextBox} activatePositionTextBox={activatePositionTextBox} activatePasswordTextBox={activatePasswordTextBox} resetTextFields={resetTextFields} deactivateNameTextBoxes={deactivateNameTextBoxes} deactivatePositionTextBox={deactivatePositionTextBox} deactivatePasswordTextBox={deactivatePasswordTextBox} />
                        </Col>
                    </div>
                </div>
            }
        </div>
    )
}

export default UserInfo
